import sortBy from 'lodash/sortBy'

import { VatRate } from '../types/vatRate'

export const getVatRatesSortedByPriorities = (vatRates: VatRate[]) => sortBy(vatRates, 'priority')
